module.exports = __webpack_public_path__ + "static/media/mars.0a396327.svg";